import React, { useState } from "react";
import { motion } from "framer-motion";

// Datos de experiencia (comunes para todos los diseños)
const experiences = [
  {
    id: 1,
    title: "Ézaro Legal",
    company: "",
    period: "Año 2025 - Actualidad",
    description: "Técnico Informático",
    achievements: [
      "Soporte IT",
      "Automatización de flujos",
      "AppScript",
      "Suit de Google",
      "Hubspot",
      "TypeScript",
    ],
  },
  {
    id: 2,
    title: "Alpha Syltec",
    company: "",
    period: "Año 2024",
    description: "Desarrollador Full-Stack (Prácticas)",
    achievements: [
      "Programación en JavaScript",
      "DOM",
      "HTML, CSS con Materialize",
      "Python",
      "Django",
      "Numpy",
      "Pandas",
      "Wordpress",
    ],
  },
  {
    id: 3,
    title: "Hosteleria",
    company: "",
    period: "Año 2022",
    description: "Camarero",
    achievements: [
      "Atención al cliente y servicio detrás de la barra",
      "Manejo de caja y asistencia en eventos"
    ],
  },
  {
    id: 4,
    title: "Gualda",
    company: "",
    period: "Año 2022",
    description: "Técnico Informático (Prácticas)",
    achievements: [
      "Soporte IT",
      "Reparación de equipos, tanto de oficina como en las tiendas físicas que poseían",
      "Sustitución de equipos",
      "Mantenimiento de sistemas y redes",
      "Configuración de equipos y software",
    ],
  },
  {
    id: 5,
    title: "Tabuenca",
    company: "",
    period: "Año 2020",
    description: "Operario de sala",
    achievements: [
      "Manipulación, revisión y etiquetado de envasado de alimentos"
    ],
  },
];

export const ExperienceAccordion = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className="py-16 px-4 max-w-4xl mx-auto">
      <motion.h2 
        className="text-3xl font-bold mb-12 text-center text-white"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <span className="text-pastel-yellow">Mi Experiencia</span>
      </motion.h2>

      <div className="space-y-4">
        {experiences.map((exp, index) => (
          <motion.div
            key={exp.id}
            className={`rounded-xl overflow-hidden border border-gray-700 shadow-xl ${
              activeIndex === index 
                ? "" 
                : ""
            }`}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: index * 0.1 }}
          >
            <button
              className="w-full p-5 text-left flex justify-between items-center"
              onClick={() => setActiveIndex(activeIndex === index ? -1 : index)}
            >
              <div className="flex items-center">
                <div className="w-8 h-8 rounded-full bg-pastel-yellow mr-4 flex items-center justify-center">
                  <span className="text-gray-900 font-bold">{exp.id}</span>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-pastel-yellow">{exp.title}</h3>
                  <p className="text-gray-400 text-sm">{exp.period}</p>
                </div>
              </div>
              <motion.div
                animate={{ rotate: activeIndex === index ? 180 : 0 }}
                className="text-pastel-yellow"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </motion.div>
            </button>
            
            {activeIndex === index && (
              <motion.div
                initial={{ height: 0, opacity: 0 }}
                animate={{ height: "auto", opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                transition={{ duration: 0.3 }}
                className="px-5 pb-5"
              >
                <p className="text-gray-300 mb-4 font-bold">{exp.description}</p>
                <h4 className="font-semibold text-gray-200 mb-2">Objetivos:</h4>
                <ul className="grid grid-cols-1 md:grid-cols-2 gap-2">
                  {exp.achievements.map((achievement, i) => (
                    <motion.li 
                      key={i}
                      className="flex items-start text-gray-400"
                      initial={{ opacity: 0, x: 10 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ delay: 0.2 + i * 0.05 }}
                    >
                      <span className="text-pastel-yellow mr-2">✓</span>
                      {achievement}
                    </motion.li>
                  ))}
                </ul>
              </motion.div>
            )}
          </motion.div>
        ))}
      </div>
    </div>
  );
};